import { create } from 'zustand';

import { ToolSmartResizeRetry } from './components/ToolSmartResizeRetry';
import { SMART_RESIZE_RETRY_HELPER_TEXT, SMART_RESIZE_RETRY_SUGGESTIONS } from './constants';
import { createSmartResizeRetrySlice, type SmartResizeRetrySlice } from './store/createSmartResizeRetrySlice';
import { buildImprovementNotes, formatSmartResizeRetryChatMessage } from './utils/formatRetryFeedback';

export type { SmartResizeRetryIntervention } from './types';
export {
  buildImprovementNotes,
  formatSmartResizeRetryChatMessage,
  SMART_RESIZE_RETRY_HELPER_TEXT,
  SMART_RESIZE_RETRY_SUGGESTIONS,
  ToolSmartResizeRetry,
};

export const useSmartResizeRetryStore = create<SmartResizeRetrySlice>()((...args) => ({
  ...createSmartResizeRetrySlice()(...args),
}));

export const useActiveSmartResizeRetry = () => useSmartResizeRetryStore((state) => state.intervention);
